import React from 'react';
import { BrowserRouter as Router,Switch, Route, Link } from "react-router-dom";
import TopBar from "./topbar/TopBar";
import Home from './pages/home/Home';
import Register from './pages/register/Register';
import Login from './pages/login/Login';
import Write from './pages/write/Write';
import Settings from './pages/settings/Settings';
import SinglePage from './pages/single/SinglePage';

function App() {
  const user = true;
  return (
    <Router>
<TopBar/>
<Switch>
    <Route exact path="/">
      <Home/>
    </Route>
    <Route path="/register"> { user? <Home/>:<Register/>}
    </Route>
    <Route exact path="/login"> {user ? <Home/> :<Login/>}
    </Route>
    <Route path="/write"> {user ? <Write/> : <Register/>}
      
    </Route>
    <Route path="/settings">{user ? <Settings/>: <Register/>}     
    </Route> 
    <Route path="/post/:postId">
      <SinglePage/>
    </Route>
</Switch>
    </Router>
  );
}

export default App;
